import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useGoogleMap } from "@react-google-maps/api";

const MapControl = ({ position, children, zIndex = 0 }) => {
  const map = useGoogleMap();

  const [container] = useState(document.createElement("div"));

  useEffect(() => {
    const controlsContainer = map.controls[position];

    controlsContainer.push(container);

    return () => {
      const index = controlsContainer.indexOf(container);
      if (index !== -1) {
        controlsContainer.removeAt(index);
      }
    }; // eslint-disable-next-line
  }, [map]);

  useEffect(() => {
    container.style.zIndex = zIndex; // eslint-disable-next-line
  }, [zIndex]);

  return createPortal(children, container);
};

export default MapControl;
